<template>
  <page-header></page-header>

  <div class="product-info">
    <h2>{{ selectedProduct.name }}</h2>
    <button v-if="tasks.length > 0" class="add-task-button" @click="exportToCSV">Export to CSV</button>
    <button class="add-task-button" @click="openAddTask()">Add a Task</button>
    <!-- <button class="add-task-button" @click="navigateToRevisions(selectedProduct)">View Revisions</button> -->
    <!-- <button class="importCSV-button-assessment" @click="navigateToImportAssessmentTasks(selectedProduct)">Import
              Assessment Tasks</button> -->
    <button class="importCSV-button" @click="navigateToImportTasks(selectedProduct)">Import Practical
      Tasks</button>
  </div>

  <div class="container-fluid-trainee">
    <vue-good-table :columns="columns" :rows="processedRows"
    :pagination-options="{
      enabled: true,
      perPage: perPage
    }" 
    :search-options="{
      enabled: true
    }" 
    :sort-options="{
      enabled: true,
    }"
    >
      <template #table-row="props">
        <span v-if="props.column.field === 'chapt_no'" class="ata-cell"
          :class="{ 'unknown-chapter-cell': props.row.chapter_unknown }"
          :title="props.row.chapter_unknown ? 'This ATA chapter number does not exist in the Chapters table' : ''">
          <font-awesome-icon v-if="props.row.chapter_unknown" :icon="['fas', 'triangle-exclamation']" class="unknown-chapter-icon" />
          {{ props.row.chapt_no }}
        </span>
        <span v-else-if="props.column.field === 'reference'" class="reference-cell">
          <template v-for="(part, index) in splitReference(props.formattedRow[props.column.field])" :key="index">
            {{ part }}<br v-if="index < splitReference(props.formattedRow[props.column.field]).length - 1" />
          </template>
        </span>
        <span v-else-if="props.column.field === 'actions'" class="center-icons">
          <font-awesome-icon icon="edit" class="edit-icon" title="Edit task" @click="openEditTask(props.row.task_id)" />
          <font-awesome-icon icon="history" class="history-icon edit-icon" title="View task revisions"
            @click="viewTaskRevisions(props.row.task_id)" />
          <font-awesome-icon icon="trash-alt" class="delete-icon" title="Delete"
            @click="deleteTask(props.row.task_id)" />
        </span>
        <span v-else :title="String(props.formattedRow[props.column.field] ?? '')">
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
  <view-task-revisions-modal v-if="showTaskRevisionsModal" @close="closeTaskRevisions"></view-task-revisions-modal>
  <task-modal v-if="showTaskModal" :mode="modalMode" :task="selectedTask" :tasks="tasks" :productId="productId" :projectId="null" :product="selectedProduct"
    @close="closeTaskModal" @saved="closeTaskModal"></task-modal>
</template>

<script>
import PageHeader from '@/components/Examiner/Header.vue';
import axios from 'axios';
import { VueGoodTable } from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import './productPage.css';
import ViewTaskRevisionsModal from './ViewTaskRevisionsModal.vue';
import TaskModal from './AddEditTaskModal.vue';

export default {
  name: 'productPage',
  components: {
    PageHeader,
    VueGoodTable,
    TaskModal,
    ViewTaskRevisionsModal,
  },
  data() {
    return {
      productId: this.$route.params.productId,
      selectedProduct: '', // Holds the selected product
      products: [], // Holds the list of products
      chapters: [],
      searchQuery: '', // Holds the user's search query
      tasks: [],
      perPage: 10,
      showEditTask: false,
      showTaskRevisionsModal: false,
      filteredTasksLength: 0,
      customColor: 'rgb(218, 248, 252, 0.7)',
      showTaskModal: false,
      modalMode: "add",   // or 'edit'
      selectedTask: null,
      columns: [
        { label: 'ATA No', field: 'chapt_no', sortable: true, thClass: 'vgt-ata-column', tdClass: 'vgt-ata-column' },
        { label: 'Task No', field: 'task_no', sortable: true, thClass: 'vgt-task-no-column', tdClass: 'vgt-task-no-column' },
        { label: 'MT/AT', field: 'manob', sortable: true, thClass: 'vgt-manob-column', tdClass: 'vgt-manob-column' },
        { label: 'Scope', field: 'scope', sortable: true, thClass: 'vgt-task-no-column', tdClass: 'vgt-task-no-column' },
        { label: 'Description', field: 'description', sortable: true, thClass: 'vgt-description-column', tdClass: 'vgt-description-column' },
        { label: 'Reference', field: 'reference', sortable: true, thClass: 'vgt-reference-column', tdClass: 'vgt-reference-column' },
        // { label: 'Skill', field: 'skill', sortable: true, thClass: 'vgt-category-column', tdClass: 'vgt-category-column' },
        // { label: 'P1', field: 'P1', sortable: true, thClass: 'vgt-P1-column', tdClass: 'vgt-P1-column' },
        // { label: 'P2', field: 'P2', sortable: true, thClass: 'vgt-P1-column', tdClass: 'vgt-P1-column' },
        { label: 'Category', field: 'category', sortable: true, thClass: 'vgt-category-column', tdClass: 'vgt-category-column' },
        { label: 'Actions', field: 'actions', sortable: false, thClass: 'vgt-actions-large-column', tdClass: 'vgt-actions-large-column' },
      ],
    };
  },
  computed: {
    processedRows() {
      const map = this.chapterMap;
      return (this.tasks || []).map(t => {
        const chapterName = map[String(t.chapt_no)] || map[String(t.chapt_no).replace(/^0+/, '')];
        return {
          ...t,
          chapter_name: chapterName || 'N/A',
          chapter_unknown: !chapterName,
        };
      });
    },
    uniqueScopes() {
      return [...new Set(this.tasks.map(t => t.scope).filter(Boolean))];
    },
    uniqueChapters() {
      return [...new Set(this.tasks.map(t => t.chapt_no).filter(Boolean))];
    },
    uniqueManobs() {
      return [...new Set(this.tasks.map(t => t.manob).filter(Boolean))];
    },
    uniqueSkills() {
      return [...new Set(this.tasks.map(t => t.skill).filter(Boolean))];
    },
    uniqueP1() {
      return [...new Set(this.tasks.map(t => t.P1).filter(v => v !== null && v !== undefined))];
    },
    uniqueP2() {
      return [...new Set(this.tasks.map(t => t.P2).filter(v => v !== null && v !== undefined))];
    },
    uniqueCategories() {
      return [...new Set(this.tasks.map(t => t.category).filter(Boolean))];
    },
    chapterMap() {
      return this.chapters?.reduce((map, chapter) => {
        map[chapter.chapt_no] = chapter.name;
        return map;
      }, {}) || {};
    }
  },
  methods: {
    updateDropdown() {
      const addDropdownFilter = (field, items) => {
        const col = this.columns.find(c => c.field === field);
        if (!col) return;

        col.filterOptions = {
          enabled: true,
          placeholder: "All",
          filterDropdownItems: items,
          filterFn: (rowValue, filterValue) => {
            if (!filterValue) return true;
            return rowValue === filterValue;
          }
        };
      };

      addDropdownFilter("scope", this.uniqueScopes);
      addDropdownFilter("chapt_no", this.uniqueChapters);
      addDropdownFilter("manob", this.uniqueManobs);
      addDropdownFilter("skill", this.uniqueSkills);
      addDropdownFilter("P1", this.uniqueP1);
      addDropdownFilter("P2", this.uniqueP2);
      addDropdownFilter("category", this.uniqueCategories);
    },
    splitReference(value) {
      if (!value) return [''];
      return String(value).split('\\');
    },
    exportToCSV() {
      const exportColumns = this.columns.filter(c => c.field !== 'actions');
      const escapeCsvValue = (value) => {
        const str = value === null || value === undefined ? '' : String(value);
        return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
      };

      const headerRow = exportColumns.map(c => c.label);
      const dataRows = this.processedRows.map(row => exportColumns.map(c => row[c.field]));
      const csvContent = '\u{FEFF}' + [headerRow, ...dataRows]
        .map(row => row.map(escapeCsvValue).join('|'))
        .join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const now = new Date();
      const dateTime = `${String(now.getDate()).padStart(2, '0')}_${String(now.getMonth() + 1).padStart(2, '0')}_${now.getFullYear()}_${String(now.getHours()).padStart(2, '0')}_${String(now.getMinutes()).padStart(2, '0')}_${String(now.getSeconds()).padStart(2, '0')}`;
      const productName = (this.selectedProduct?.name || 'product').replace(/[^a-z0-9]+/gi, '_');

      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `${productName}_tasks_${dateTime}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    navigateToImportTasks(selectedProduct) {
      this.$router.push({
        name: 'importTasks', params: { productId: selectedProduct.product_id }
      });
    },
    navigateToImportAssessmentTasks(selectedProduct) {
      this.$router.push({
        name: 'ImportAssessmentTasks', params: { productId: selectedProduct.product_id }
      });
    },
    openAddTask() {
      this.modalMode = "add";
      this.selectedTask = null;
      this.showTaskModal = true;
    },
    openEditTask(task_id) {
      this.modalMode = "edit";
      this.selectedTask = this.tasks.find(s => s.task_id === task_id);
      this.showTaskModal = true;
    },
    async closeTaskModal() {
      this.showTaskModal = false;
      await this.fetchTasks();
    },
    async fetchProducts() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        const response = await axios.get(`/api/products/${this.productId}`, { headers });
        this.selectedProduct = response.data;
        this.productId = response.data.product_id;
        const chapterResponse = await axios.get(`/api/chapters`, { headers });
        this.chapters = chapterResponse.data;
        console.log('chapters', this.chapters);
      } catch (error) {
        console.error('Error fetching Practical Elements:', error);
      }
    },
    async fetchTasks() {
      const token = localStorage.getItem('token');
      try {
        // Fetch tasks by product_id using API endpoint and authorization token
        const response = await this.$http.get(`/api/tasks/products/${this.productId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        // Assign fetched tasks to local data 'tasks'
        this.tasks = response.data.filter(task => task.project_id === null);
        // this.tasks.sort((a, b) => a.task_no - b.task_no);
        console.log(this.tasks);

        // Sort tasks by chapt_no and task_no
        this.tasks.sort((a, b) => {
          const chapRegex = /^(\d+)([A-Za-z]*)$/;
          const [, numA, suffixA] = (a.chapt_no || '').match(chapRegex) || [];
          const [, numB, suffixB] = (b.chapt_no || '').match(chapRegex) || [];

          const chapterComparison = Number(numA) - Number(numB);
          if (chapterComparison !== 0) return chapterComparison;

          const suffixComparison = (suffixA || '').localeCompare(suffixB || '');
          if (suffixComparison !== 0) return suffixComparison;

          const taskA = parseInt(a.task_no, 10);
          const taskB = parseInt(b.task_no, 10);

          return taskA - taskB;
        });

        this.updateDropdown();
      } catch (error) {
        console.error('Error fetching tasks:', error);
      }
    },
    viewEditTask(task_id) {
      localStorage.setItem('task_id', task_id);
      this.showEditTask = true; // Show the modal when the button is clicked
    },
    closeEditTask() {
      this.showEditTask = false; // Close the modal
      this.fetchTasks();
    },
    viewTaskRevisions(task_id) {
      localStorage.setItem('task_id', task_id);
      this.showTaskRevisionsModal = true; // Show the modal when the button is clicked
    },
    closeTaskRevisions() {
      this.showTaskRevisionsModal = false; // Close the modal
    },
    deleteTask(task_id) {
      if (confirm("Are you sure you want to delete this task?")) {
        if (confirm("This action will PERMANENTLY delete the task from the database. Do you wish to continue?")) {
          // If the user confirms the deletion, send a request to delete the task.
          const token = localStorage.getItem('token');
          const headers = { Authorization: `Bearer ${token}` };

          axios
            .delete(`/api/tasks/${task_id}`, { headers })
            .then(response => {
              if (response.status === 200) {
                // Remove the deleted task from the local data
                this.tasks = this.tasks.filter(t => t.task_id !== task_id);

                window.alert('Task deleted Successfully');
              }
            })
            .catch(error => {
              if (error.isOffline === true) {
                this.$emit('close');
                return;
              }
              if (error.response && error.response.status === 500) {
                const errorMessage = error.response.data.message;
                const isForeignKeyConstraintError = errorMessage.includes('SQLSTATE[23000]') && errorMessage.includes('Integrity constraint violation: 1451');

                if (isForeignKeyConstraintError) {
                  window.alert('This Task cannot be deleted because it is used in one or more Logbooks.');
                } else {
                  window.alert('An error occurred while deleting the Task. Please try again.');
                }
              } else {
                console.error('An unexpected error occurred:', error);
                window.alert('An unexpected error occurred. Please try again.');
              }
            });
        }
      }
    },
  },
  async mounted() {
    console.log(this.$store.state.selectedProduct);
    this.fetchProducts(); // Fetch product data
    this.fetchTasks();
  },
};
</script>

<style scoped>
.edit-icon {
  font-size: 16px;
  /* Adjust the size as needed */
  color: #615f5f;
  /* Change the color to your preference */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  margin-left: 5px;
  margin-right: 5px;
}

.edit-icon:hover {
  color: #2b2a2a;
  /* Change the color to your preference */
  cursor: pointer;
  transform: scale(1.1);
  /* Example transform for scaling on hover */
}

.history-icon {
  color: rgb(33, 71, 238);
}

.history-icon:hover {
  color: rgb(25, 55, 187);
}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  margin-left: 5px;
  margin-right: 5px;
}

.delete-icon:hover {
  color: #a82222;
  cursor: pointer;
  transform: scale(1.1);
}

.product-info {
  display: flex;
  width: 100%;
  text-align: center;
  margin-top: 0;
  padding: 0px 0;
}

.product-info h2 {
  margin-left: 1%;
  margin-top: 20px;
  font-size: 26px;
  width: relative;
  display: inline-block;
  width: 70%;
}

.product-info h3 {
  margin-top: 10px;
  font-size: 22px;
  width: relative;
  display: inline-block;
}

.importCSV-button {
  margin-left: 0;
  border-radius: 5px;
  min-width: 220px;
  height: 30px;
  background-color: #02092b;
  color: white;
  border: 1px solid #00051d;
  margin-right: 10px;
  padding: 0 10px;
  margin-left: 15px;
  margin-top: 10px;
}

.importCSV-button:hover {
  background-color: #031363;
  color: white;
  transform: scale(1.05);
  transition: 0.3s;
}

.importCSV-button-assessment {
  margin-left: 0;
  border-radius: 5px;
  min-width: 250px;
  height: 30px;
  background-color: #02092b;
  color: white;
  border: 1px solid #00051d;
  margin-right: 10px;
  padding: 0 10px;
  margin-left: 15px;
  margin-top: 10px;
}

.importCSV-button-assessment:hover {
  background-color: #031363;
  color: white;
  transform: scale(1.05);
  transition: 0.3s;
}


.add-task-button {
  margin-left: 0;
  border-radius: 5px;
  min-width: 170px;
  height: 30px;
  background-color: #463333;
  color: white;
  border: 1px solid #200d0d;
  margin-right: 10px;
  padding: 0 10px;
  margin-left: 15px;
  margin-top: 10px;
}

.add-task-button:hover {
  background-color: #2b1616;
  color: white;
  transform: scale(1.05);
  transition: 0.3s;
}

ul {
  margin-bottom: 0px;
}

.pagination-button-container {
  display: flex;
  justify-content: space-between;
  /* Pushes left, center, and right */
  align-items: flex-end;
  /* Vertically center everything */
  width: 100%;
}

.pagination-container {
  margin-top: 20px;
  margin-left: 15px;
}

.pagination {
  display: flex;
  list-style: none;
  padding-left: 0;
  gap: 0px;
  margin: 0px;
  margin-left: 15px;
}

.pagination-info {
  font-size: 14px;
  color: #666;
  text-align: center;
}


.addtasks-button {
  margin-left: auto;
  border-radius: 5px;
  min-width: 250px;
  height: 30px;
  background-color: #275b8f;
  color: #ffffff;
  border: 1px solid #001479;
  margin-right: 10px;
  padding: 0 10px;
  flex: 1;
}

.addtasks-button:hover {
  background-color: #173757;
  cursor: pointer;
  transform: scale(1.05);
  transition: 0.3s;
  border: 1px solid #042242;
}

.container-fluid-trainee {
  padding-top: 10px;
  width: 98%;
  margin-left: 1%;
  margin-right: 1%;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.export-button {
  width: 200px;
  padding: 5px 5px;
  background-color: #48a0ff;
  color: white;
  border: 1px solid #007bff;
  border-radius: 8px;
  cursor: pointer;
  height: 40px;
  float: right;
}
.export-button:hover {
  background-color: #0056b3;
}

.unknown-chapter-cell {
  display: inline-block;
  background-color: #ffe0b2;
  border: 1px solid #e65100;
  color: #7a3e00;
  font-weight: 600;
  border-radius: 4px;
  padding: 2px 8px;
}

.unknown-chapter-icon {
  color: #e65100;
  margin-right: 4px;
}

.row-pending-update {
  background-color: #fff8cc !important;
}

.row-pending-delete {
  background-color: #ffd6d6 !important;
}

.pending-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px !important;
  background: #f1a53b;
  color: #fff;
}

.pending-badge:hover {
  background: #f09618 !important;
  color: #fff !important;
  cursor: pointer !important;
}

.pending-new-tasks-card {
  margin: 20px 20px 16px 20px;
  padding: 16px 18px;
  background: #fffdf2;
  border: 1px solid #f0d98c;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.pending-new-tasks-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  text-align: left;
}

.pending-new-tasks-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #5f4b00;
}

.pending-count {
  min-width: 28px;
  height: 28px;
  padding: 0 10px;
  border-radius: 14px;
  background: #f0ad4e;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pending-new-tasks-table-wrapper {
  overflow-x: auto;
}

.pending-new-tasks-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.pending-new-tasks-table thead tr {
  background: #fff4cc;
}

.pending-new-tasks-table th,
.pending-new-tasks-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #eee;
  vertical-align: top;
}

.pending-subtext {
  display: block;
  margin-top: 4px;
  color: #7a6a2f;
  font-size: 13px;
}

.pending-new-tasks-table th {
  font-weight: 600;
  color: #5c4a00;
  white-space: nowrap;
}

.pending-new-tasks-table tbody tr:last-child td {
  border-bottom: none;
}

.pending-new-tasks-table tbody tr:hover {
  background: #fffaf0;
}

.pending-description-cell {
  min-width: 240px;
  max-width: 420px;
  white-space: normal;
  word-break: break-word;
}

.pending-actions-cell {
  width: 70px;
  text-align: center !important;
  white-space: nowrap;
}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
  margin-left: 8px;
}

.delete-icon:hover {
  color: #a82222;
  cursor: pointer;
  transform: scale(1.1);
}

.reference-cell {
  display: inline-block;
  line-height: 1.4;
}

.vgt-reference-column {
  white-space: normal !important;
  vertical-align: top;
}
</style>